import { storage } from 'core';

const getToken = async () => await storage.getItem('token');

export default getToken;
